// extracted by mini-css-extract-plugin
export default {"pointContainer":"VerticalCircularSteps_pointContainer__sP-+t"};